<div class="header flex justify-between items-center py-2 pb-5 border-b border-text mb-5">
  <div class="header-left flex items-center">
    <!-- Mobile Toggle Button -->
    <!-- <button class="md:hidden mr-4 text-xl cursor-pointer" (click)="mobileToggle.emit()">
      <i class="fas fa-bars"></i>
    </button> -->
  </div>

  <div class="header-right flex items-center gap-5">
    <div class="relative notification-icon text-xl cursor-pointer transition-all duration-300 hover:text-primary">
      <i class="fas fa-bell"></i>
      <span class="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
    </div>

    <!-- User Profile Dropdown -->
    <div class="relative user-dropdown">
      <div class="profile flex items-center gap-2 cursor-pointer" (click)="toggleDropdown()">
        <!-- <div class="profile-img w-10 h-10 rounded-full bg-primary flex items-center justify-center font-bold">M</div> -->
        <app-user-initial [name]="username ?? ''"></app-user-initial>
        <div class="profile-name font-medium">{{ username }}</div>
        <div class="dropdown-arrow text-sm transition-all duration-300" [class.rotate-180]="dropdownOpen">
          <i class="fas fa-chevron-down"></i>
        </div>
      </div>

      <!-- Dropdown Menu -->
      <div *ngIf="dropdownOpen"
        class="absolute right-0 mt-2 w-48 bg-bg-dark rounded-lg shadow-lg border border-text z-50 overflow-hidden">
        <div class="py-1">
          <!-- User Info -->
          <div class="px-4 py-3 border-b border-text">
            <p class="text-sm font-medium text-white">{{ username }}</p>
            <p class="text-xs text-text mt-1">Account Settings</p>
          </div>

          <!-- Logout Option -->
          <button (click)="userLogout()"
            class="w-full text-left px-4 py-2 text-sm text-text hover:bg-bg hover:text-white transition-all duration-200 flex items-center gap-3">
            <i class="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </button>
        </div>
      </div>

      <!-- Click outside to close dropdown -->
      <div *ngIf="dropdownOpen" class="fixed inset-0 z-40" (click)="closeDropdown()"></div>
    </div>
  </div>
</div>